<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-row :gutter="24">
        <a-col :span="24">
          <!-- 条件搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item label="名称/手机号">
                    <a-input v-model="queryParam.name" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="单位名称">
                    <a-input v-model="queryParam.tenantName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="区域">
                    <a-select
                      show-search
                      v-model="queryParam.regionId"
                      placeholder="请选择区域"
                      style="width: 100%"
                      allow-clear
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option v-for="(d, index) in userRegion" :key="index" :value="d.id">{{
                        d.name
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item :label="userType == 2 ? '分销商' : '经销商'" prop="tenantAgentId">
                    <a-select
                      v-model="queryParam.tenantAgentId"
                      :placeholder="userType == 2 ? '请选择分销商' : '请选择经销商'"
                      style="width: 100%"
                      allow-clear
                      show-search
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option v-for="(d, index) in agentList" :key="index" :value="d.id">{{
                        d.name
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <span
                    class="table-page-search-submitButtons"
                    :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                  >
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                    <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                      {{ advanced ? '收起' : '展开' }}
                      <a-icon :type="advanced ? 'up' : 'down'" />
                    </a> -->
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作 -->
          <!-- 数据展示 -->
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="false"
            :bordered="tableBordered"
          >
            <!-- tips: 此处的status 其实是后端的enable字段，所以status '0' 代表的是开启  status '1' 代表的是关闭 -->
            <span slot="isWaterWorker" slot-scope="text, record">
              {{ record.isWaterWorker ? '是' : '否' }}
            </span>
            <span slot="isInspection" slot-scope="text, record">
              {{ record.isInspection ? '是' : '否' }}
            </span>
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <span slot="operation" slot-scope="text, record" v-if="record.id !== 1">
              <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:user:edit']"> 修改 </a>
              <a-divider
                type="vertical"
                v-hasPermi="['system:user:resetPwd', 'system:user:edit', 'system:user:resetPwd']"
              />
              <a-dropdown v-hasPermi="['system:user:resetPwd', 'system:user:edit', 'system:user:remove']">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-icon type="double-right" />
                  更多
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-hasPermi="['system:user:resetPwd']">
                    <a @click="handleDelete(record)" v-hasPermi="['system:user:remove']"> 删除 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['system:user:resetPwd']">
                    <a @click="$refs.resetPassword.handleResetPwd(record)"> 重置密码 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['system:user:edit']">
                    <a @click="$refs.authRole.handleAuthRole(record)"> 分配角色 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['sys:fund:connect:list']">
                    <a @click="$refs.CreateAcount.handleUpdate(record, undefined)"> 资金账户 </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
          <!-- 分页 -->
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          />
        </a-col>
      </a-row>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { employee } from '@/api/system/user'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import { pageMy } from '@/api/pressure/dispatch'
import { regionList } from '@/api/pressure/region'
export default {
  name: 'User',
  mixins: [tableMixin],
  dicts: ['sys_normal_disable', 'sys_user_sex'],
  props: {
    role: {
      type: String,
    },
  },
  data() {
    return {
      list: [],
      userRegion: [],
      selectedRowKeys: [],
      agentList: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          children: [],
        },
      ],
      // 日期范围
      dateRange: [],
      tenantListed: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined,
      },
      columns: [
        {
          title: '序号',
          key: 'index',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => {
            // 从1开始编号
            return index + 1
            // 如果分页，可以加上页码偏移量：
            // return (this.pagination.current - 1) * this.pagination.pageSize + index + 1;
          },
        },
        // {
        //   title: '用户名',
        //   dataIndex: 'userName',
        //   align: 'center',
        // },
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '手机号',
          dataIndex: 'userPhone',
          align: 'center',
        },
        {
          title: '积分',
          dataIndex: 'point',
          align: 'center',
        },
        {
          title: '单位名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '单位简称',
          dataIndex: 'referredName',
          align: 'center',
        },
        {
          title: '是否水工',
          dataIndex: 'isWaterWorker',
          align: 'center',
          scopedSlots: { customRender: 'isWaterWorker' },
        },
        {
          title: '是否验收员',
          dataIndex: 'isInspection',
          align: 'center',
          scopedSlots: { customRender: 'isInspection' },
        },
      ],
    }
  },
  filters: {},
  created() {
    if (this.role) {
      if (this.role == 'YSY00') {
        this.queryParam.type = 0
      } else {
        this.queryParam.type = 1
      }
      this.columns.splice(-2)
    }
    // this.getQu()
    // if (!this.isTree) {
    //   // this.columns.pop()
    //   this.queryParam.tenantId = this.tenantId
    //   console.log(this.tenantId, 'this.tenantId')
    //   console.log(this.columns, 'columnscolumns')
    // }
    if (this.userType === 1 || this.userType === 0) {
      this.getMy(2)
      this.getQu()
    }
     if (this.userType == 2) {
      this.getMy(3)
    }

    this.getList()
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 查询经销商
    getMy(type) {
      pageMy({ type: type }).then((res) => {
        console.log(res, 'resres=====0--，。。。')
        this.agentList = res.data.records
      })
    },
    // 查询区域
    getQu() {
      regionList().then((res) => {
        console.log(res, '的点点滴滴')
        this.userRegion = res.data
      })
    },
    /** 查询用户列表 */
    getList() {
      this.loading = true
      employee(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      if (this.dateRange.length) {
        this.queryParam.createBeginTime = this.dateRange[0] + ' ' + '00:00:00'
        this.queryParam.createEndTime = this.dateRange[1] + ' ' + '23:59:59'
      } else {
        this.queryParam.createBeginTime = ''
        this.queryParam.createEndTime = ''
      }
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined,
      }
      if (this.role) {
        if (this.role == 'YSY00') {
          this.queryParam.type = 0
        } else {
          this.queryParam.type = 1
        }
      }
      console.log(this.role, 'ddd顶顶顶顶')
      setTimeout(() => {
        this.handleQuery()
      }, 0)
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    clickDeptNode(deptId) {
      this.queryParam.deptId = deptId
      this.handleQuery()
    },
    /* 用户状态修改 status 0开启 1关闭*/
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const text = row.status === 0 ? '启用' : '关闭'
      const status = row.status === 1 ? 0 : 1
      changeUserStatus(row.id, status)
        .then((res) => {
          if (res.success) {
            row.status = status
            this.$message.success(text + '成功', 3)
          } else {
            row.status = oldStatus
            this.$message.error(`${text}失败, ${res.message}`, 3)
          }
        })
        .catch(() => {
          this.$message.error(text + '异常', 3)
        })
    },
    cancelHandleStatus(row) {},
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const userIds = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + userIds + '的数据',
        onOk() {
          return delUser(userIds).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    // 选择用户
    handleSubChoose() {
      this.$emit('backCange', this.selectedRowKeys)
      console.log(this.selectedRowKeys, 'selectedRowKeysselectedRowKeysselectedRowKeys')
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/user/export',
            {
              ...that.queryParam,
            },
            `user_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
